module.exports = "../study/imgs/maps/Nagano/S8/Hazard/Slopefailure/Nagano_Slopefailure_HadGEM2_RCP85_Mid.png";